export enum UploadFormLabelEnum {
  DisplayName = 'Asset Name',
  GradeLevel = 'Grade Level',
  Program = 'Learning Experience',
  Pillar = 'JA Competency Categories',
  KnowledgeSkillsAndAbilities = 'Knowledge, Skills and Abilities',
  Time = 'Time',
  KeyTerms = 'Keywords',
  BriefDescription = 'Brief Description',
  Competency = 'JA Competencies',
  Language = 'Language',
  Languages = 'Languages',
  AccessExpirationDate = 'Access Expiration Date',
  LearningObjectives = 'Learning Objectives',
  AccessibleToStudents = 'Student Facing',
  File = 'File',
  FileType = 'File Type',
  WebLink = 'Web Link',
}
